import {Component, Input, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {PdfDetails} from '../../models/pdf/pdf-details';

@Component({
    selector: 'app-pdf-page-quickscan',
    templateUrl: './pdf-page-quickscan.component.html',
    styleUrls: ['./pdf-page-quickscan.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfPageQuickscanComponent {

    @Input() pdfDetails: PdfDetails;

    protected getVersionId() {
        if (this.pdfDetails.quickscanDefinition) {
            return this.pdfDetails.quickscanDefinition.versionId;
        }
        return this.pdfDetails.projectAnalysisDefinition?.versionId;
    }
}
